import React from 'react'
import { observer } from 'mobx-react'

import QuestionSlidePreview from './previews/QuestionSlide'
import StyledSlidePreview from './previews/StyledSlide'
import VerbatimSlidePreivew from './previews/VerbatimSlide'
import InheritedSlidePreview from './previews/InheritedSlide'
import CrosstabSlidePreview from './previews/CrosstabSlide'

const PreviewSlide = ({
    isActive, slide, isCollapsed, onDelete,
}) => {
    const hasActiveFilter = [...slide.question.values()]
        .some((q) => (q.filter?.question?.rules?.length ?? 0) > 0)

    const handleDelete = (e) => {
        e.stopPropagation()
        if (onDelete) onDelete()
    }

    const renderPreview = () => {
        switch (slide.template) {
            case 'title':
                return <StyledSlidePreview includeLogo />
            case 'sectionHeader':
                return <StyledSlidePreview />
            case 'specification':
            case 'summary':
            case 'swot':
                return <StyledSlidePreview includeHeader />
            case 'crosstab':
                return <CrosstabSlidePreview />
            case '1x1':
            case 'derived':
            case 'oss':
            case 'lmx':
                return <QuestionSlidePreview slide={slide} count={1} />
            case '1x2':
                return <QuestionSlidePreview slide={slide} count={2} />
            case '2x1':
                return <QuestionSlidePreview slide={slide} count={2} dir="column" />
            case '3x1':
                return <QuestionSlidePreview slide={slide} count={3} />
            case '4x1':
                return <QuestionSlidePreview slide={slide} count={4} />
            case '2x2':
                return <QuestionSlidePreview slide={slide} count={4} wrap />
            case 'verbatim':
                return <VerbatimSlidePreivew />
            case 'inherited':
                return <InheritedSlidePreview slide={slide} />
            default:
                return (
                    <div style={{ backgroundColor: '#EFF4F6', height: '100%' }}>
                        <div style={{ height: 10, backgroundColor: '#102E4A', position: 'relative' }}>
                            <img src="https://cdn.explori.com/images/logo_explori.png" alt="explori logo" style={{ height: 5, position: 'absolute', right: 2, top: 2 }} />
                        </div>
                    </div>
                )
        }
    }

    return (
        <div
            className={`pp-slide-preview ${isActive ?  'pp-active-slide' : ''} ${isCollapsed ? 'pp-slide-preview-collapsed' : ''}`}
        >
            {renderPreview()}
            {hasActiveFilter && (
                <div className="pp-slide-preview__filter-indicator" aria-label="Slide has filters applied">
                    <i className="fas fa-filter" aria-hidden="true" />
                </div>
            )}
            {onDelete && (
                <button
                    type="button"
                    className="pp-slide-preview__delete"
                    aria-label="Delete slide"
                    onClick={handleDelete}
                >
                    <i className="fas fa-trash" aria-hidden="true" />
                </button>
            )}
        </div>
    )
}

export default observer(PreviewSlide)
